export enum SortByTransactionField {
    ID = "id",
    TIMESTAMP = "timestamp",
    CUSTOMER_NAME = "customerName",
    TOTAL_PAYABLE = "totalPayable",
    STATUS = "status",
    TOTAL_ITEMS = "totalItems",
    STORE_NAME = "storeName",
    PAYMENT_METHOD = "paymentMethod",
}